import React, { useState, useEffect } from 'react'
import './requestStatus.css'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Popover from '@mui/material/Popover';
import { getLeaves } from '../../api/leaveApi'
import { useSelector, useDispatch } from 'react-redux'
import { handleAddLeave } from '../../state/leaveSlice'
import moment from 'moment'


function ExpandableCell({ value }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={{display: 'flex',flexDirection: 'column'}}>
      <div dangerouslySetInnerHTML={{__html: expanded ? value : value?.slice(0, 70)+'...'}}>
      </div>
      {value?.length > 100 && (
        <button
          className="request__status-table_btn"
          type="button"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'view less' : 'view more'}
        </button>
      )}
    </div>
  );
}

const ActionCell = ({param}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
      setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `popover-${param?.row?.staff}` : undefined;
  return (
  <div className='ticket__popover-popover'>
      <i class='bx bx-dots-vertical-rounded ticket__popover-icon'
      onClick={handleClick}></i>
      <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
          }}
          sx={{
              '& .MuiPopover-paper': {
                  boxShadow: '0 0 10px 0px rgba(0, 0, 0, 0.1)',
                  minWidth: 100,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'start',
              },
          }}
      >
          <button className="ticket__popover-btn">Update</button>
      </Popover>
  </div>
  )
}

const columns = [
  {
    field: 'leaveType',
    headerName: 'Leave Type',
    width: 150,
  },
  {
    field: 'days',
    headerName: 'Durations',
    width: 80,
  },
  {
    field: 'reason',
    headerName: 'Reasons',
    width: 250,
    renderCell: (param) => <ExpandableCell value={param.row.reason} />
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    width: 140,
    renderCell: (param) => (
    <span>
      {moment(param.row.startDate).format('MMMM DD YYYY')}
    </span>
    )
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    width: 140,
    renderCell: (param) => (
      <span>
        {moment(param.row.endDate).format('MMMM DD YYYY')}
      </span>
      )
  },
  {
    field: 'createdAt',
    headerName: 'Applied On',
    width: 140,
    renderCell: (param) => (
      <span>
        {moment(param.row.createdAt).calendar()}
      </span>
      )
  },
  {
    field: 'uhApproval',
    headerName: 'Unit Head',
    width: 100,
    renderCell: (param) => (
      <span className={`request__status-table_span
        ${param.row.uhApproval.toLowerCase()}
      `}>{param.row.uhApproval}</span>
    )
  },
  {
    field: 'hrApproval',
    headerName: 'HR',
    width: 100,
    renderCell: (param) => (
      <span className={`request__status-table_span
        ${param.row.hrApproval.toLowerCase()}
      `}>{param.row.hrApproval}</span>
    )
  },
  {
    field: 'adminApproval',
    headerName: 'MP',
    width: 100,
    renderCell: (param) => (
      <span className={`request__status-table_span
        ${param.row.adminApproval.toLowerCase()}
      `}>{param.row.adminApproval}</span>
    )
  },
  // {
  //   field: 'action',
  //   headerName: 'Action',
  //   width: 90,
  //   renderCell: (param) => <ActionCell param={param}/>
  // },
];


const RequestStatus = () => {
    const {user} = useSelector((state)=> state.user)
    const {leave} = useSelector((state)=> state.leave)
    const dispatch = useDispatch()


  const fetchLeaveRequest = async ()=>{
    try{
        const res = await getLeaves(user?.token)
        dispatch(handleAddLeave(res?.data))
    }catch(error){
        console.log(error)
    }
  }

  useEffect(()=>{
      fetchLeaveRequest()
  },[])

  return (
    <section className='request__status'>
      {/* HEADING */}
      <div className="heading">
        <div className="heading__box">
            <div className="heading-item">
              <h3 className="heading-title">Leave Request Status | </h3>
              <i class='bx bx-home heading__title-icon'></i>
              <Link to="/" className="heading-text">
                  Home <i class='bx bx-chevron-right heading-icon'></i>
              </Link>
              <span className="heading-text">
                  Leave Request Status<i class='bx bx-chevron-right heading-icon'></i>
              </span>
            </div>
              <p className="heading-text">
                You have made a request for leave on the following dates. <br/>
                Please check back regularly as your superView the status of your leave request.
              </p>
          </div>
      </div>
      <div className="request__status-container">

        <div className="request__status-content">
          {/* HEADING */}
          <div className="request__status-heading">
            <div className="request__status-search">
              <span>Search:</span>
              <input type="text" placeholder='Search....'
              className='request__status-input'/>
            </div>
          </div>

          {/* DATA TABLE */}
          <div className="request__status-table">
            <DataGrid
              getRowId={(rows => rows._id)}
              rows={leave ?? []}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5]}
              checkboxSelection
              disableRowSelectionOnClick
              getRowHeight={() => 'auto'} 
              getEstimatedRowHeight={() => 100}
              sx={{
                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                  py: 0.5,
                },
                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                  py: '10px',
                },
                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                  py: '15px',
                },
              }}
              experimentalFeatures={{ lazyLoading: true }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default RequestStatus